import { buildCardsFromDescriptionPrompt } from '@/ai/prompts'
import { fetchJsonResponse, streamJsonResponses } from '@/ai/api'
import { trackCardsGenerated } from '@/utils/helpHero'

export const generateCardsFromDescription = async ({
  workflow,
  cardTypes,
  userDescription,
  stream = false,
  onChunkReceived,
  abortController
}) => {
  if (!workflow || !workflow.aiVersion) {
    return null
  }
  if (stream && typeof onChunkReceived !== 'function') {
    return null
  }

  const { messages } = buildCardsFromDescriptionPrompt({
    workflow,
    cardTypes,
    userDescription,
    stream
  })

  if (stream) {
    const response = await streamJsonResponses({
      messages,
      aiVersion: workflow.aiVersion,
      onChunkReceived,
      signal: abortController?.signal
    })

    trackCardsGenerated(response)

    return response || null
  } else {
    const response = await fetchJsonResponse({
      messages,
      aiVersion: workflow.aiVersion,
      signal: abortController?.signal
    })

    trackCardsGenerated(response)

    return response || null
  }
}
